import UserGroupList from './UserGroupList';

export default UserGroupList;
